window.productSelectCallback = function (parameters) {
  // parameters: { variant, money_format, selector, product }
  var variant = parameters.variant;
  var money_format = parameters.money_format;
  var selector = parameters.selector;
  var product = parameters.product;
  var bundleProducts = parameters.bundleProducts;
  var isBundle = bundleProducts && bundleProducts.length;

  if (variant) {
    var compare_at_price = variant.compare_at_price;
    var available = variant.available;
    var price = variant.price;
    const formatted_price = Shopify.formatMoney(price, money_format);
    const formatted_compare = Shopify.formatMoney(
      compare_at_price,
      money_format
    );

    const form = jQuery('#' + selector.domIdPrefix).closest('form');

    $('.js-product-price').each(function () {
      $(this).html(formatted_price);
    });
    $('.js-compare-at-price').each(function () {
      $(this).html(formatted_compare);
    });

    // Change Button Text and disable
    // checked by sticky add to cart banner to update its CTA button
    if (!isBundle) {
      const addToCartBtn = document.getElementById('add-to-cart');
      if (available) {
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.disabled = true;
      }

      // Update waitlist form with new variant ID (triggers attributeChangedCallback to reset submit button state)
      const waitlistForm = document.querySelector(
        '.waitlist-pdp-container waitlist-form'
      );
      if (waitlistForm) {
        waitlistForm.setAttribute('variant-id', variant.id);
        waitlistForm.setAttribute('product-id', product.id);
      }
    }

    // Go to matching slide from swatch click
    if (variant.featured_image) {
      var scaleImageSize = function (path, size) {
        var validateImage = function (str) {
          var imageTypes = [
            'jpeg',
            'JPEG',
            'JPG',
            'jpg',
            'png',
            'PNG',
            'TIFF',
            'tiff',
            'GIF',
            'gif'
          ];
          return (
            imageTypes.find(function (type) {
              return str.includes(type);
            }) || null
          );
        };

        var potentialImageType = validateImage(path);

        if (!potentialImageType) {
          return console.error('Failed to find valid image type');
        }

        var parts = path.split('.' + potentialImageType);

        if (parts[2]) {
          return console.error(
            'Failed to properly split asset using .${fileType} as delimiter'
          );
        }

        return parts[0] + '_' + size + '.' + potentialImageType + parts[1];
      };

      $('.product-images-nav li div').each(function () {
        var feat = scaleImageSize(variant.featured_image.src, '150x');
        var bg = $(this).css('background-image');
        bg = bg.split('?v=')[0];
        feat = feat.split('?v=')[0];

        if (bg.indexOf(feat) > -1) {
          $('.product-images-slider').slick(
            'slickGoTo',
            $(this).parent().index()
          );
        }
      });
    }

    // Swatches
    if (!isBundle) {
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = form.find(
          '.swatch[data-option-index="' +
            i +
            '"] :radio[value="' +
            variant.options[i] +
            '"]'
        );

        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }

      validateSwatches(variant.option1, variant, product);

      if (BSS.Components.StickyATCBanner) {
        BSS.Components.StickyATCBanner.updateStickyBannerFromVariantChange();
      }

      // Change size swatch labels
      $('.swatch :radio:checked').each(function () {
        let label = $(this).val();
        let labelLowercase = label.toLowerCase();

        if (labelLowercase == 's') {
          label = 'Small';
        } else if (labelLowercase == 'm') {
          label = 'Medium';
        } else if (labelLowercase == 'l') {
          label = 'Large';
        } else if (labelLowercase == 'xl') {
          label = 'X-large';
        } else if (labelLowercase == '2xl') {
          label = 'XX-large';
        } else if (labelLowercase == '3xl') {
          label = 'XXX-large';
        }

        $(this).closest('.swatch').find('.swatch-selected').text(label);
      });
    }
  }
};

// crawls the DOM to ensure the availability of subsequently displayed product options
// corresponds to whichever first option the user has selected
const validateSwatches = (variant1, variant, product) => {
  const swatchGroups = document.querySelectorAll('.swatch');

  // Get the currently selected color (variant1 is the first option, which is color)
  const currentColor = variant1;

  swatchGroups.forEach(swatchGroup => {
    const currentOptionIndex = parseInt(swatchGroup.dataset.optionIndex);
    const isColorSwatch = swatchGroup.classList.contains('color');
    const swatchElements = swatchGroup.querySelectorAll('.swatch-element');

    swatchElements.forEach(swatchElement => {
      const dataValue = swatchElement.dataset.optionValue;

      // Check if this option value exists
      const option_field = `option${currentOptionIndex + 1}`;
      const variantsWithThisValue = product.variants.filter(
        v => v[option_field] === dataValue
      );

      // For SIZE swatches: Only show sizes that exist for the CURRENT color
      if (!isColorSwatch) {
        // Check if this size exists for the currently selected color
        const variantForCurrentColorAndSize = product.variants.find(
          v => v.option1 === currentColor && v[option_field] === dataValue
        );

        // If this size doesn't exist for the current color, hide the swatch (don't remove)
        if (!variantForCurrentColorAndSize) {
          swatchElement.style.display = 'none';
          return;
        } else {
          // If it does exist, make sure it's visible
          swatchElement.style.display = '';
        }
      }

      // For COLOR swatches: Just check if any variants exist
      if (isColorSwatch && variantsWithThisValue.length === 0) {
        swatchElement.style.display = 'none';
        return;
      } else if (isColorSwatch) {
        // Make sure color swatches are visible if they have variants
        swatchElement.style.display = '';
      }

      // Now handle the soldout logic for remaining swatches
      let isAvailable;

      if (isColorSwatch) {
        isAvailable = product.variants.some(
          ({ available, options }) =>
            available && options[currentOptionIndex] === dataValue
        );
      } else {
        isAvailable = product.variants.some(variantCheck => {
          return (
            variantCheck.available &&
            variantCheck.options[currentOptionIndex] === dataValue &&
            variantCheck.options.every(
              (optionValue, index) =>
                index === currentOptionIndex || optionValue === variant.options[index]
            )
          );
        });
      }

      swatchElement.classList.toggle('soldout', !isAvailable);
    });
  });
};

$(function () {
  $('.swatch :radio').on('change', function (e) {
    var radioValue = $(this).val();
    let optionValue;
    const isColorChange =
      $(e.target).parents('.swatch')[0].dataset.optionName === 'color';

    if (isColorChange) {
      optionValue = e.target.value;

      // Auto-select first available size only if productSelect becomes disabled (invalid variant)
      setTimeout(() => {
        const productSelect = document.getElementById('productSelect');

        // Check if productSelect is disabled (means current variant combination is invalid)
        if (productSelect && productSelect.disabled) {
          const sizeSwatchGroup = document.querySelector('.swatch:not(.color)');
          if (sizeSwatchGroup) {
            // Uncheck any currently selected size radio button
            const currentlySelectedSizeRadio = sizeSwatchGroup.querySelector(
              'input[type="radio"]:checked'
            );
            if (currentlySelectedSizeRadio) {
              currentlySelectedSizeRadio.checked = false;
            }

            // Find first visible and available (non-soldout) size swatch element
            const availableSizeSwatch = sizeSwatchGroup.querySelector(
              '.swatch-element:not([style*="display: none"]):not([style*="display:none"]):not(.soldout)'
            );
            if (availableSizeSwatch) {
              const sizeRadio = availableSizeSwatch.querySelector(
                'input[type="radio"]'
              );
              if (sizeRadio) {
                // Click the label to trigger proper selection
                const sizeLabel = availableSizeSwatch.querySelector('label');
                if (sizeLabel) {
                  sizeLabel.click();
                }
              }
            }
          }
        }
      }, 100); // Small delay to ensure validateSwatches has run and productSelect state is updated
    } else {
      var getOption = document.getElementsByName('option-0');

      for (var i = 0; i < getOption.length; i++) {
        if (getOption[i].checked) {
          optionValue = getOption[i].value;
        }
      }
    }
    // js-pdp-swatch to avoid collision with pdp recommended product card's .swatch class
    var swatchGroups = document.getElementsByClassName('js-pdp-swatch');
    if (swatchGroups && swatchGroups.length > 1) {
      for (var i = 1; i < swatchGroups.length; i++) {
        var targetRadioBtns = document.getElementsByName('option-' + i);
        var selectedRadioBtn;

        for (var j = 0; j < targetRadioBtns.length; j++) {
          if (targetRadioBtns[j].checked) {
            selectedRadioBtn = targetRadioBtns[j];
          }
        }

        var dataValue = selectedRadioBtn.dataset.wrapperLookup;
        var option_1_selector = document.querySelector(
          '[data-option="option1"]'
        );
        var option_var_selector = document.querySelector(
          '[data-option="option' + (i + 1) + '"]'
        );

        option_1_selector.value = optionValue;
        $(option_1_selector).trigger('change');

        option_var_selector.value = selectedRadioBtn.value;
        $(option_var_selector).trigger('change');

        var newChecked = document.querySelector(
          '[data-value="' + dataValue + '"]'
        ).firstElementChild;
        newChecked.checked = 'true';
      }
    } else if (swatchGroups && swatchGroups.length == 1) {
      var option_1_selector = document.querySelector('[data-option="option1"]');
      $('[data-option="option1"]').val(radioValue).trigger('change');
    }
  });
  $(document).on('click', '.soldout-cross', function () {
    $(this).siblings('label').trigger('click');
  });
});

/* Gallery */
function initProductSlider() {
  $('.product-images-slider').slick({
    arrows: false,
    mobileFirst: true,
    dots: false,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: true,
    swipe: true,
    fade: false,
    responsive: [
      {
        // With mobileFirst, Slick applies these settings above the breakpoint.
        breakpoint: 1023,
        settings: {
          adaptiveHeight: true,
          variableWidth: false,
          swipe: false,
          fade: true
        }
      }
    ]
  });

  function setActiveNavItem(index) {
    const $navImgs = $('.product-images-nav .product-images-nav-img');
    $navImgs.removeClass('active').attr('aria-current', 'false');
    $navImgs.eq(index).addClass('active').attr('aria-current', 'true');
  }

  // Update nav on dot/swipe/keyboard change
  $('.product-images-slider').on(
    'beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      setActiveNavItem(nextSlide);
    }
  );

  // Change on nav click
  $('.product-images-nav li').on('click', function () {
    setActiveNavItem($(this).index());
    $('.product-images-slider').slick('slickGoTo', $(this).index());
  });

  // Change on nav hover
  $('.product-images-nav li').on('mouseenter', function () {
    setActiveNavItem($(this).index());
    $('.product-images-slider').slick('slickGoTo', $(this).index());
  });
}
if ($('.product-images-slider').length) {
  initProductSlider();
}

$(document).ready(function () {
  $.fn.showFlex = function () {
    this.css('display', 'flex');
  };
  var $nav = $('.product-images-nav');
  var $prevButton = $('.scroll-control--prev');
  var $nextButton = $('.scroll-control--next');
  // initial button show
  if (
    $nav.prop('scrollWidth') &&
    $nav.innerWidth() < $nav.prop('scrollWidth')
  ) {
    $nextButton.showFlex();
  }

  function canScroll(direction) {
    switch (direction) {
      case 'left':
        return $nav.scrollLeft() > 0;
      case 'right':
        return $nav.prop('scrollWidth') - $nav.innerWidth() > $nav.scrollLeft();
    }
  }
  function scroll(direction) {
    const nav = $nav[0];
    if (!nav) return;
    nav.scrollBy({ left: direction === 'left' ? -300 : 300, behavior: 'smooth' });
  }
  function handleHorizontalScroll() {
    if (canScroll('left')) {
      $prevButton.showFlex();
    } else {
      $prevButton.hide();
    }
    if (canScroll('right')) {
      $nextButton.removeClass('disabled');
      $nextButton.showFlex();
    } else {
      $nextButton.hide();
    }
  }
  $nav.on('scroll', function () {
    handleHorizontalScroll();
  });
  $prevButton.on('click', function () {
    scroll('left');
  });
  $nextButton.on('click', function () {
    scroll('right');
  });
});

// cdp event
const productJsonElement = document.getElementById('product-json');
if (productJsonElement) {
  const productJSON = JSON.parse(productJsonElement.innerHTML);
  if (productJSON) sendCDPProductViewedEvent(productJSON);
}
